<template>
  <div id="orderedit-popup">
    <div class="in-line" style="margin-left:0px;">
    Order: <input id="order-no" 
                  v-on:keyup.enter="save"
                  size="5" v-model="orderNoVal"/>
    </div>
    <div class="hdr-right" style="margin-top:10px; margin-right:16px">
      Status:
      <select v-model="statusVal">
        <option>Not Placed</option>
        <option>Placed</option>
        <option>Cancelled</option>
        <option>Received</option>
      </select>
    </div>
    <br/>
    <div v-show="statusVal != 'Not Placed'">
      <div class="date-label">
        Ordered:  <datepicker v-model="dateVal"
                          v-bind:format="'MMM d, yyyy'" 
                          v-bind:wrapper-class="'date-wrapper'"
                          v-bind:input-class="'date-input'" />
      </div>
      <div class="date-label"  style="margin-left:34px;">
        Received:  <datepicker v-model="recvVal"
                          v-bind:format="'MMM d, yyyy'" 
                          v-bind:wrapper-class="'date-wrapper'"
                          v-bind:input-class="'date-input'" />
      </div>
      <br/>
      <div class="date-label">
        First Due:  <datepicker v-model="due1Val"
                          v-bind:format="'MMM d, yyyy'" 
                          v-bind:wrapper-class="'date-wrapper'"
                          v-bind:input-class="'date-input'" />
      </div>
      <div class="date-label" style="margin-left:30px;">
        Last Due:  <datepicker v-model="due2Val"
                          v-bind:format="'MMM d, yyyy'" 
                          v-bind:wrapper-class="'date-wrapper'"
                          v-bind:input-class="'date-input'" />
      </div>
    </div>
    <div style="display:inline-block">
        Parts/Pack: <input id="order-ppp" v-on:keyup.enter="save"
                    size="5" v-model="partsPerPackVal"/>
    </div>
    <div class="in-line" style="margin-left:35px;">
        Num Packs: <input id="order-packcnt" v-on:keyup.enter="save"
                    size="5" v-model="packCountVal"/>
    </div>

    <div style="display:inline-block">
        Cost/Pack: <input id="order-cost" v-on:keyup.enter="save"
                    size="5" v-model="costPerPackVal"/>
    </div>
    <div v-show="statusVal != 'Not Placed'">
      <div style="display:inline-block; margin-left:35px;">
          Amount Paid: <input id="order-paid" v-on:keyup.enter="save"
                      size="5" v-model="amountPaidVal"/>
      </div>
    </div>
    <br/>
    <div class="in-line" style="font-weight:bold;margin-top:10px;">
        Part Qty: {{partQty}}
    </div>
    <div class="in-line" style="font-weight:bold;margin-left:20px;margin-top:10px;">
        Cost/Part: ${{partCost}}
    </div>
    <div class="in-line" style="font-weight:bold;margin-left:20px;">
        Total: ${{totalCost}}
    </div>

    <div>
        Part URL: <input id="order-url1" v-on:keyup.enter="save"
                    size="22" v-model="partUrlVal"/>
        <button @click="goPart" class=btn> View </button>
    </div>
    <div v-show="statusVal != 'Not Placed'">
      <div style="display:inline-block">
          Vendor Order #: <input id="order-vpartno" v-on:keyup.enter="save"
                      size="15" v-model="vendOrderNoVal"/>
      </div>
      <div>
          Order URL: <input id="order-url2" v-on:keyup.enter="save"
                      size="20" v-model="orderUrlVal"/>
          <button @click="goOrder" class=btn> View </button>
      </div>
    </div>
    <div>
      <button @click="cancel" class=btn> 
        Cancel
      </button>
      <button v-show="!this.newOrder" @click="del" class=btn> 
        Delete
      </button>
      <div v-show="this.nextBtnText" class="in-line">
        <button @click="submit" class=btn> 
          {{nextBtnText}}
        </button>
      </div>
      <button @click="save" class=btn id="save"> 
        Save
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'order-editor',
  components: {Datepicker},
  data () {
    return {
      order: null,
      orderNoVal: '',
      statusVal: '',
      dateVal: null,
      recvVal: null,
      due1Val: null,
      due2Val: null,
      partsPerPackVal: null,
      packCountVal:    null,
      costPerPackVal: null,
      amountPaidVal: null,
      partUrlVal: '',
      vendOrderNoVal: '',
      orderUrlVal: '',
      nextBtnText: 'Order',
    }
  },

  props: [
    'selPartNo',
    'orders',
    'orderNo',
    'newOrder',
    'part',
  ],

  computed: {
    partQty () {
      return (this.partsPerPackVal * this.packCountVal).toFixed(0);
    },
    partCost () {
      return (this.totalCost / this.partQty).toFixed(2);
    },
    totalCost () {
      return (this.costPerPackVal * this.packCountVal).toFixed(2);
    },
  },

  methods: {
    goPart () {
      window.open(this.partUrlVal, 'p4assem1');
    },
    goOrder () {
      window.open(this.orderUrlVal, 'p4assem2');
    },

    save () {
      this.order.status       = this.statusVal;
      this.order.date         = this.dateVal.getTime();
      this.order.recv = 
           this.recvVal ? this.recvVal.getTime() : null;
      this.order.due1         = this.due1Val.getTime();
      this.order.due2         = this.due2Val.getTime();
      this.order.partsPerPack = this.partsPerPackVal;
      this.order.packCount    = this.packCountVal;
      this.order.costPerPack  = this.costPerPackVal;
      this.order.amountPaid   = this.amountPaidVal;
      this.order.partUrl      = this.partUrlVal;
      this.order.vendOrderNo  = this.vendOrderNoVal;
      this.order.orderUrl     = this.orderUrlVal;
      if(this.order.partUrl) {
        const vendorMatches = /([a-zA-Z]+)\.com/.exec(this.order.partUrl);
        if(vendorMatches) 
          this.order.vendor = vendorMatches[1];
      }
      if(this.newOrder) {
        let matchingOldOrder = null;
        let havePart = false;
        this.orders.forEach( (oldOrder) => {
          if(oldOrder.orderNo === +this.orderNoVal) {
            matchingOldOrder = oldOrder;
            oldOrder.parts.forEach( (partNo) => {
              if(partNo === this.part.partNo) {
                havePart = true;
              }
            });
          }
        });
        if(matchingOldOrder) {
          if(!havePart) {
            matchingOldOrder.parts.push(this.selPartNo);
            this.$parent.dbUpdateOrder(this.order);
          }
        }
        else {
          this.orders.unshift(this.order);
          this.$parent.dbAddOrder(this.order);
        }
      }
      else {
        for(let order of this.orders) {
          if(order.orderNo === this.orderNo) {
            Object.assign(order, this.order);
            this.$parent.dbUpdateOrder(order);
            break;
          }
        }
      }
      this.$parent.lineClicked(this.selPartNo);
      this.$parent.showOrderEditor = false;
    },
    del () {
      if(confirm(`Do you really want to permanently delete Order ${this.orderNo} for Part ${this.part.partNo}?`)) {
        let selIdx = null;
        for(let [idx, order] of this.orders.entries()) {
          if(order.orderNo === this.orderNo) {
            selIdx = idx;
            break;
          }
        }
        if(selIdx !== null) {
          this.orders.splice(selIdx,1);
          this.$parent.dbDelOrder(this.orderNo);
          this.$parent.sortOrders();
        }
      }
      this.$parent.showOrderEditor = false;
    },
    submit () {
      switch(this.nextBtnText) {
        case 'Place Order':
          this.statusVal = 'Placed';
          break;
        case 'Receive Order':
          this.statusVal = 'Received';
          break;
        case 'Uncancel Order':
          this.statusVal = 'Not Placed';
          break;
        default: return
      }
      this.save();
    },

    cancel () {
      // this.dateVal = "";
      // this.recvVal = "";
      this.$parent.showOrderEditor = false;
    }
  },

  async mounted () {
    this.order = null;
    const now = Date.now();
    if(this.newOrder) {
      this.$parent.orderNo = await this.$parent.dbNewOrderNo();
      this.date = now;
      this.order = {
        status:  'Not Placed',
        orderNo: this.$parent.orderNo,
        parts: [this.selPartNo],
        date:    now,
        due1:    now,
        due2:    now,
        partsPerPack: 1,
        packCount:    1,
        costPerPack:  0,
        amountPaid:   0,
        partUrl:     '',
        orderUrl:    '',
      };
    } 
    else {
      for(let order of this.orders) {
        if(this.orderNo === order.orderNo) {
          this.order = order;
          break;
        }
      }
    }
    if(this.order === null) {
      console.error('no old order found',{thisorders: this.orders});
      this.cancel();
      return;
    }
    this.orderNoVal      = this.order.orderNo;
    this.dateVal         = new Date(this.order.date || now);
    this.recvVal = 
         this.order.recv ? new Date(this.order.recv) : null;
    this.due1Val         = new Date(this.order.due1 || now);
    this.due2Val         = new Date(this.order.due2 || now);
    this.statusVal       = this.order.status || 'Not Placed';
    this.partsPerPackVal = this.order.partsPerPack;
    this.packCountVal    = this.order.packCount;
    this.costPerPackVal  = this.order.costPerPack;
    this.amountPaidVal   = this.order.amountPaid;
    this.partUrlVal      = this.order.partUrl;
    this.vendOrderNoVal  = this.order.vendOrderNo;
    this.orderUrlVal     = this.order.orderUrl;

    switch (this.order.status) {
      case 'Not Placed': this.nextBtnText = 'Place Order';    break;
      case 'Placed':     this.nextBtnText = 'Receive Order';  break;
      case 'Cancelled':  this.nextBtnText = 'Uncancel Order'; break;
      case 'Received':   this.nextBtnText = '';               break;
    }
  }
}
</script>

<style>
.date-label{
  display: inline-block;
}
input.date-input {
  width: 90px;
}
.date-wrapper {
  display: inline-block;
  margin-top: 10px;
}
</style>

<style scoped>

#orderedit-popup {
  position: absolute;
  left: 100px;
  top:  20px;
  width: 360px;
  border: 2px solid black;
  padding: 10px;
  background-color: #ffffdd;
  font-size:15px;
  z-index: 2;
}
.hdr {
  display: inline-block;
  font-size: 16px;
  margin-top:5px;
}
.hdr-middle {
  font-size: 16px;
  margin-left: 20px;
  display: inline-block;
}
.hdr-bold {
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  margin-top:5px;
}
.hdr-middle-bold {
  font-size: 16px;
  font-weight: bold;
  margin-left: 20px;
  display: inline-block;
}
.hdr-right {
  font-size: 16px;
  font-weight: bold;
  float: right;
}
.in-line {
  display: inline-block;
  margin-left: 10px;
}
input {
    margin-top: 10px;
}
.btn {
  color: black;
  font-weight: bold;
  background-color: lightblue;
  margin-top: 10px;
  margin-left: 5px;
}
#save {
  float: right;
}
</style>
